import { defineContent, type DefinedContent } from '@post-office/define-content';

export const registeredContent: DefinedContent<
	[
		'headingLabel',
		'bodyLabel',
		'callToActionLabel',
		'whyAmISeeingThisModalMessage',
		'whyAmISeeingThisModalReason',
	]
> = defineContent({
	default: {
		headingLabel: {
			id: 'post-office.confluence-rovo-onboarding-banner.heading',
			defaultMessage: 'Rovo is ready for you',
			description: 'Heading for the Rovo onboarding banner.',
			role: 'title',
		},
		bodyLabel: {
			id: 'post-office.confluence-rovo-onboarding-banner.body',
			defaultMessage:
				"Power up your workspace. Set up and configure connectors to unlock all Rovo's potential.",
			description: 'Body text for the Rovo onboarding banner.',
			role: 'description',
		},
		callToActionLabel: {
			id: 'post-office.confluence-rovo-onboarding-banner.call.to.action',
			defaultMessage: 'Get started',
			description: 'Call to action button on the Rovo onboarding banner.',
		},
		whyAmISeeingThisModalMessage: {
			id: 'post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.message',
			defaultMessage:
				"We think setting up Rovo and connecting apps will improve your team's productivity. You're seeing this because Rovo is available to your team, and as an organizational admin you can extend Rovo's features by configuring connectors.",
			description: 'Message explaining why the user is seeing this banner.',
		},
		whyAmISeeingThisModalReason: {
			id: 'post-office.confluence-rovo-onboarding-banner.why-am-i-seeing-this.reason',
			defaultMessage: 'Rovo is available to your team and you are an organizational admin',
			description: 'Reason for showing the banner.',
		},
	},
});
